
const UPDATE_MESSAGE_UNREAD_NUM = function (state, payload) {
  state.messageUnreadNum = payload;
};

export const mutations = {
  UPDATE_MESSAGE_UNREAD_NUM
};
